import { Box } from "convertupleads-theme";
import LogHeader from "./LogHeader";
import LogTable from "./LogTable";

const LogViewer = () => {
  return (
    <>
      <LogHeader />
      <Box component="main" sx={{ width: "100%" }}>
        <LogTable />
      </Box>
    </>
  );
};

export default LogViewer;
